export const standartDateFormat = "DD.MM.YYYY";
export const standartDateTimeFormat = "DD.MM.YYYY HH:mm";